@if (component(); as component) {
<section *ngIf="squadPlayers().length > 0" class="squad">
  <div class="squad__header">
    <div class="squad__title">{{ 'squad.meetTheFirstTeam' | translate }}</div>
  </div>

  <tisa-carousel
    #carousel
    class="squad__list"
    (scrolledToEnd)="onButtonRightStatusChanges($event)"
    (scrolledToBeginning)="onButtonLeftStatusChanges($event)"
  >
    @for (player of squadPlayers(); track player.id) {
    <tisa-player-tile [squadPlayer]="player" class="squad__tile"></tisa-player-tile>
    }
  </tisa-carousel>

  <div class="squad__footer">
    <a
      class="squad__squad-button"
      [routerLink]="['/', locale(), 'team']"
      [queryParams]="{team_id: teamId(), season_id: seasonId()}"
    >
      <span>{{ 'squad.seeWholeSquad' | translate }}</span>
      <app-icon name="chevron-right"></app-icon>
    </a>

    <div class="squad__arrows-container">
      <button
        class="squad__arrow squad__arrow--left"
        (click)="carousel.scrollLeft()"
        [disabled]="buttonLeftDisabled()"
      >
        <app-icon name="arrow-left"></app-icon>
      </button>
      <button
        class="squad__arrow squad__arrow--right"
        (click)="carousel.scrollRight()"
        [disabled]="buttonRightDisabled()"
      >
        <app-icon name="arrow-right"></app-icon>
      </button>
    </div>
  </div>
</section>
}
